import { render, staticRenderFns } from "./BesoinsSanteTns.vue?vue&type=template&id=2727a5c5&scoped=true&"
import script from "./BesoinsSanteTns.vue?vue&type=script&lang=js&"
export * from "./BesoinsSanteTns.vue?vue&type=script&lang=js&"
import style0 from "./BesoinsSanteTns.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BesoinsSanteTns.vue?vue&type=style&index=1&id=2727a5c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2727a5c5",
  null
  
)

export default component.exports